'use es6';

import Immutable from 'immutable';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
const EMPTY_MAP = Immutable.Map();
const EMPTY_SET = Immutable.Set();
const initialMoreAppsState = new Immutable.Map({
  hasCategoryResults: false,
  results: new Immutable.OrderedSet()
});
const initialCompatibilityState = {
  compatibility: EMPTY_MAP,
  portalTiers: EMPTY_SET
};
const initialState = Immutable.fromJS({
  compatibility: initialCompatibilityState,
  listingViewsCache: EMPTY_MAP,
  listingViewsFetchErrorCache: EMPTY_MAP,
  listingViewsFetchStatusCache: EMPTY_MAP,
  moreApps: initialMoreAppsState,
  referrer: null
});
const details = (state = initialState, {
  type,
  payload,
  meta
}) => {
  switch (type) {
    case ActionTypes.DETAILS_FETCH_REQUESTED:
      {
        const {
          slug
        } = meta;
        return state.withMutations(mutableState => mutableState.setIn(['listingViewsFetchStatusCache', slug], RequestState.PENDING).deleteIn(['listingViewsFetchErrorCache', slug]));
      }
    case ActionTypes.DETAILS_FETCH_RECEIVED:
      {
        const {
          slug
        } = meta;
        return state.withMutations(mutableState => mutableState.setIn(['listingViewsCache', slug], payload).setIn(['listingViewsFetchStatusCache', slug], RequestState.SUCCEEDED));
      }
    case ActionTypes.DETAILS_FETCH_FAILED:
      {
        const {
          slug
        } = meta;
        return state.withMutations(mutableState => mutableState.setIn(['listingViewsFetchErrorCache', slug], payload).setIn(['listingViewsFetchStatusCache', slug], RequestState.FAILED));
      }
    case ActionTypes.FEATURE_COMPATIBILITY_RECEIVED:
      return state.set('compatibility', payload);
    case ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED:
      return state.set('moreApps', payload);
    case ActionTypes.DETAILS_MORE_APPS_RESET:
      return state.set('moreApps', initialMoreAppsState);
    case ActionTypes.DETAILS_REFERRER_SET:
      {
        return state.set('referrer', payload);
      }
    case ActionTypes.DETAILS_REFERRER_RESET:
      {
        return state.set('referrer', null);
      }
    default:
      return state;
  }
};
export default details;